export default __webpack_public_path__ + "static/media/back-glass.08b80936.png";